const formatDateTime = (value) => {
  if (!value) return '-';
  try {
    return new Date(value).toLocaleString();
  } catch {
    return '-';
  }
};

const AuditLogsTable = ({ logs, loading }) => {
  return (
    <div className="overflow-x-auto rounded-[28px] border border-[color:var(--admin-border)] bg-white shadow-sm">
      <table className="min-w-full text-sm">
        <thead className="border-b border-[color:var(--admin-border)] text-xs uppercase tracking-[0.24em] text-[color:var(--admin-icon)]">
          <tr>
            <th className="px-4 py-4 text-left">Time</th>
            <th className="px-4 py-4 text-left">Admin</th>
            <th className="px-4 py-4 text-left">Action</th>
            <th className="px-4 py-4 text-left">Endpoint</th>
            <th className="px-4 py-4 text-left">Status / Meta</th>
            <th className="px-4 py-4 text-left">IP</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan="6" className="px-4 py-8 text-center text-[color:var(--admin-text)]">
                Loading audit logs...
              </td>
            </tr>
          )}
          {!loading && !logs.length && (
            <tr>
              <td colSpan="6" className="px-4 py-8 text-center text-[color:var(--admin-text)]">
                No audit logs found.
              </td>
            </tr>
          )}
          {logs.map((log) => (
            <tr key={log.id} className="border-b border-[color:var(--admin-border)] last:border-b-0">
              <td className="px-4 py-4 text-[color:var(--admin-text)]">{formatDateTime(log.createdAt)}</td>
              <td className="px-4 py-4">
                <div className="font-medium text-[color:var(--admin-heading)]">
                  {log.admin?.fullName || log.admin?.email || 'System'}
                </div>
                <div className="text-xs text-[color:var(--admin-text)]">{log.admin?.email || '-'}</div>
              </td>
              <td className="px-4 py-4 text-[color:var(--admin-heading)]">{log.action}</td>
              <td className="px-4 py-4 text-[color:var(--admin-text)]">
                <div>{log.endpoint || '-'}</div>
                <div className="text-xs uppercase tracking-[0.18em]">{log.method || '-'}</div>
              </td>
              <td className="px-4 py-4 text-[color:var(--admin-text)]">
                {log.meta?.statusCode ? <div>Status {log.meta.statusCode}</div> : <div>-</div>}
                {log.meta && Object.keys(log.meta).length > 0 && (
                  <div className="mt-1 text-xs">
                    {Object.entries(log.meta)
                      .filter(([key]) => key !== 'statusCode')
                      .slice(0, 2)
                      .map(([key, value]) => `${key}: ${String(value)}`)
                      .join(' | ') || '-'}
                  </div>
                )}
              </td>
              <td className="px-4 py-4 text-[color:var(--admin-text)]">{log.ipAddress || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AuditLogsTable;
